import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { APP_NAVIGATION_ROUTES } from "../../router/router.constants";
import { WhatsAppAuthProvider } from "./context/WhatsAppAuthProvider";
import { WhatsAppSocketProvider } from "./context/WhatsAppSocketProvider";
import { WhatsAppProvider } from "./context/WhatsAppChatProvider";

const WhatsAppList = Loadable(lazy(() => import("./views/WhatsAppList")));

export const whatsAppRoutes = [
  {
    path: APP_NAVIGATION_ROUTES.chats,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[]} allowFullAccess>
        <WhatsAppAuthProvider>
          <WhatsAppSocketProvider>
            <WhatsAppProvider>
              <WhatsAppList />
            </WhatsAppProvider>
          </WhatsAppSocketProvider>
        </WhatsAppAuthProvider>
      </AuthorizedRoute>
    ),
  },
];
